import { useRecordContext } from "react-admin";

const SOFIA_TIME_ZONE = "Europe/Sofia";

const WALL_TIME_PATTERN = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2})(?:\.\d+)?)?)?$/;

const resolvePath = (record, path) =>
  String(path)
    .split(".")
    .reduce((acc, key) => (acc == null ? undefined : acc[key]), record);

const sofiaParts = date => {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: SOFIA_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).formatToParts(date);
  const get = type => parts.find(part => part.type === type)?.value ?? "";
  return { day: get("day"), month: get("month"), year: get("year"), hours: get("hour"), minutes: get("minute") };
};

export const formatDoctoralDate = (value, withTime = false) => {
  if (!value) return "";

  const wall = typeof value === "string" ? value.match(WALL_TIME_PATTERN) : null;
  if (wall) {
    const [, year, month, day, hours, minutes] = wall;
    const datePart = `${day}.${month}.${year}`;
    return withTime ? `${datePart} ${hours ?? "00"}:${minutes ?? "00"}` : datePart;
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";

  const sofia = sofiaParts(date);
  const datePart = `${sofia.day}.${sofia.month}.${sofia.year}`;
  return withTime ? `${datePart} ${sofia.hours}:${sofia.minutes}` : datePart;
};

const DoctoralDateField = ({
  source,
  showTime = false,
  emptyText = "—",
  record: recordProp,
}) => {
  const contextRecord = useRecordContext();
  const record = recordProp ?? contextRecord;

  return <span>{formatDoctoralDate(resolvePath(record, source), showTime) || emptyText}</span>;
};

export default DoctoralDateField;
